import React from "react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
} from "@chakra-ui/react";

// An image that opens full size in a popup when clicked.
const ZoomableImage = ({ src, alt, className = "" }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <img
        src={src}
        alt={alt}
        draggable={"false"}
        onClick={onOpen}
        title="Click to enlarge"
        className={`w-full cursor-zoom-in ${className}`}
      />

      <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
        <ModalOverlay bg="blackAlpha.800" />
        <ModalContent mx={4} bg="white">
          <ModalCloseButton
            bg="white"
            color="#015AAA"
            borderRadius="full"
            zIndex={1}
          />
          <ModalBody p={2}>
            {/* On small screens keep the diagram readable and let it scroll sideways */}
            <div className="overflow-auto max-h-[85vh]">
              <img
                src={src}
                alt={alt}
                draggable={"false"}
                className="w-full min-w-[900px] lg:min-w-0"
              />
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ZoomableImage;
